var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckIcon3 = function SvgCheckIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.667 9.999h-.002a.5.5 0 0 1-.442-.27c-.703-1.355-1.49-2.46-2.41-3.376a.5.5 0 1 1 .708-.707c.802.8 1.51 1.727 2.147 2.818 1.51-2.628 3.37-4.767 5.536-6.366a.5.5 0 0 1 .594.804C8.538 4.572 6.623 6.87 5.11 9.734a.5.5 0 0 1-.442.266z"
  })));
};
export default SvgCheckIcon3;